import { gql } from "@apollo/client";

export const FETCH_FAQ = gql`
  query Faqs {
    faqs {
      error
      data {
        answer
        id
        question
      }
    }
  }
`;
